module.exports = __webpack_public_path__ + "img/牡蛎.8da79750.jpg";